import { Controller } from "@hotwired/stimulus";

// Automatically saves the entire form after changes (debounced) or when nested items are added/removed.
export default class extends Controller {
  static targets = ["status"];
  static values = { delay: { type: Number, default: 1000 } };

  connect() {
    this.form = this.element;
    this.timer = null;
    this.isSaving = false;
    this.boundSchedule = this.schedule.bind(this);
    this.form.addEventListener("input", this.boundSchedule);
    this.form.addEventListener("change", this.boundSchedule);
    this.form.addEventListener("nested-form:changed", this.boundSchedule);
  }

    disconnect() {
    this.form.removeEventListener("input", this.boundSchedule);
    this.form.removeEventListener("change", this.boundSchedule);
    this.form.removeEventListener("nested-form:changed", this.boundSchedule);
  }

  schedule() {
    if (this.isSaving) return; // don't queue during active save cycle
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.save(), this.delayValue);
  }

  saveNow(event) {
    if (event) event.preventDefault();
    this.save();
  }

  async save() {
    if (!this.form.action) return;
    this.isSaving = true;
    this.showStatus("Speichern…");
    const tokenTag = document.querySelector('meta[name="csrf-token"]');
    const token = tokenTag ? tokenTag.content : (this.form.querySelector('input[name="authenticity_token"]')?.value);
    const formData = new FormData(this.form);
    formData.append("autosave", "1");

    try {
      const response = await fetch(this.form.action, {
        method: this.form.method.toUpperCase() === 'GET' ? 'POST' : this.form.method.toUpperCase(),
        headers: {
          'Accept': 'text/vnd.turbo-stream.html, text/html, application/json',
          'X-CSRF-Token': token
        },
        body: formData,
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error(`Status ${response.status}`);
      this.showStatus("Gespeichert ✓");
    } catch (e) {
      console.error("Autosave failed", e);
      this.showStatus("Fehler beim Speichern", true);
    } finally {
      this.isSaving = false;
      setTimeout(() => this.clearStatus(), 3000);
    }
  }

  showStatus(text, isError = false) {
    if (!this.hasStatusTarget) return;
    this.statusTarget.textContent = text;
    this.statusTarget.classList.toggle('text-danger', isError);
    this.statusTarget.classList.toggle('text-success', !isError);
  }

  clearStatus() {
    if (!this.hasStatusTarget) return;
    this.statusTarget.textContent = "";
  }
}